import { render } from "./GlobalProgressSpinner.vue?vue&type=template&id=3d1e08e2&scoped=true&ts=true"
import script from "./GlobalProgressSpinner.vue?vue&type=script&lang=ts"
export * from "./GlobalProgressSpinner.vue?vue&type=script&lang=ts"

import "./GlobalProgressSpinner.vue?vue&type=style&index=0&id=3d1e08e2&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d1e08e2"]])

export default __exports__